import ResourceList from '../../../components/admin/ResourceList'

export default function LogsList({ enablePullToRefresh }) {
    return (
        <ResourceList
            enablePullToRefresh={enablePullToRefresh}
            apiUrl={'/v1/settings/logs'}
            fields={[
                {
                    column: 1,
                    wrapperEl: 'p',
                    getValue: (item) => `${item.timestamp}`,
                    getClassName: () => 'subtitle',
                },

                {
                    column: 1,
                    wrapperEl: 'pre',
                    getValue: (item) => `${item.message}`,
                },
            ]}
        />
    )
}
